import * as utils from "../../utils/utils.js";

export default function () {
  const widgetName = "agZoneFooterCards";
  const widgetOpts = agZoneFooterCardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 2,
    itemsPerPanel: 1,
    imageIsBackground: true,
    hasImages: true,
    textOverImage: true,
    buyNowButton: false,
    lazyLoadImages: false,
    moreButton: false,
    showDescription: false,
    link: ["all"],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(".ag-zone-footer .section-c").remove();
      } else {
        createFooterCards(data.items);
      }
    },
  });

  function createFooterCards(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { Title, URL } = widgetData[x];
      const $footerCard = $(this);
      const targetElement = !utils.isLocalUrl(URL) && URL ? "_blank" : "";

      $footerCard.find(".card-content").remove();

      if (URL == null) {
        $footerCard.removeAttr("href");
      }
      $footerCard.attr({ "aria-label": Title, target: targetElement });
    });
  }
}
